const ar = {
  welcomeMessage: 'Welcome aboard',
  home: 'Home',
  validate: 'Validate',
  back: 'Back',
  error: 'Error',
  active: 'Active',
  dashboard: 'Dashboard',
  verificationServices: 'Verification services',
  judicalLicenseVerification: 'Judical license verification',
  judicalLicenseDescription: 'A service that helps you verify the validity of licenses issued by the Ministry of Justice',

  lawyer: 'Lawyer',
  trainee: 'Trainee',
  authorized: 'Authorized',
  implementationServiceProvider: 'Implementation service provider',
  licenseToRepresentaPrivateLegalPerson: 'License to represent a private legal person',
  hijriDateSuffix: 'H',
  georgianDateSuffix: 'A.D',
  licenseType: 'License type',
  chooseLicenseType: 'Choose License Type',
  licenseNumber: 'License number',
  licenseNumberPlaceholder: 'ex:123',
  licenseDetails: 'License Details',
  serviceType: 'Service type',
  issuanceDate: 'Issuance date',
  terminationDate: 'Termination date',
  noResult: 'No Result',
  docIdCopiedSuccessfully: 'License Number copied successfully',

  validations: {
    fieldIsRequired: 'Field is required',
    onlyNumbers: 'Please enter numbers only',
  },

  name: 'Name',
  socialID: 'Social ID',
  licenseHolderInformation: 'License holder information',
  lawyerTrainerInformation: 'Lawyer trainer information',
  entityInformation: 'Entity information',
  entityName: 'Entity name',
  mobileNumber: 'Mobile number',
  city: 'City',
  court: 'Court',
  institutionInformations: 'Institution informations',
  institutionName: 'Institution name',
  crNumber: 'commercial number',
  phone: 'Phone',
  mobile: 'Mobile',
  institutionAddress: 'Institution address',
  district: 'District',
  neighborhood: 'Neighborhood',
  street: 'Street',
  licencedAreas: 'Licenced areas',
  backToVerification: 'Back to verification',

  serverErrors: {
    SERVER_ERROR: 'Something went wrong, please try again later',
    NO_DATA_FOUND: 'No data found',
    USER_NOT_FOUND: 'User is not found, please try again',
  },
};

export default ar;
